module.exports = __webpack_public_path__ + "img/jscx.9da74445.png";